var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgPetsAllowed = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  viewBox: "0 0 40 40"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 0h40v40H0z"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#464646",
  d: "M13.497 24.85c0-3.517 1.436-8.871 6.526-8.871 4.699 0 6.526 5.354 6.526 8.87 0 1.73-.523 3.473-1.853 3.473-3.063 0-2.797-2.03-4.629-2.03-1.662 0-1.871 2.208-4.373 2.208-1.495 0-2.197-1.754-2.197-3.65ZM14.005 17.827c.961-.742.882-2.4-.176-3.707-1.059-1.305-2.696-1.762-3.657-1.02-.96.741-.882 2.401.176 3.706s2.696 1.763 3.657 1.021ZM29.828 12.904c-.961-.742-2.598-.285-3.657 1.021-1.058 1.305-1.137 2.965-.176 3.706.96.742 2.598.285 3.657-1.02 1.058-1.306 1.137-2.965.176-3.707ZM20.73 11.385c-.306 1.752.432 3.306 1.65 3.472 1.219.167 2.455-1.119 2.763-2.87s-.431-3.307-1.65-3.473-2.455 1.12-2.762 2.871ZM19.265 11.385c.307 1.752-.431 3.306-1.65 3.472-1.218.167-2.454-1.119-2.762-2.87s.432-3.307 1.65-3.473 2.454 1.12 2.762 2.871Z"
}))));
export default SvgPetsAllowed;